<h5
  class="tw-my-2 tw-text-gray-700 dark:tw-text-gray-300 tw-font-medium tw-text-xl tw-pr-5 rounded-1"
>
  {{ menuTitleSelected }}
</h5>
<div
  class="tw-mb-2 menus-table tw-border dark:tw-border-dark-100 tw-px-0 tw-mt-4 tw-relative table-responsive"
>
  <table class="table table-head-custom table-vertical-center overflow-hidden">
    <thead class="tw-border-b dark:tw-border-dark-100">
      <tr
        class="fw-bold fs-6 tw-text-gray-800 dark:tw-text-gray-200 tw-h-[60px]"
      >
        <th class="tw-flex tw-justify-between tw-items-center">
          <!-- select all -->
          <div
            class="tw-flex-center tw-mr-[13px] ltr:tw-ml-[10px] tw-m-0 tw-mt-10"
          >
            <input
              id="selectAllClaims"
              [disabled]="claims?.length == 0"
              type="checkbox"
              [(ngModel)]="isSelectAll"
              class="form-check-input tw-mr-0 tw-ml-2"
              (input)="onSelectAll($event)"
            />
            <label
              for="selectAllClaims"
              class="tw-font-medium"
              [class]="
                claims?.length
                  ? 'tw-text-gray-800 dark:tw-text-gray-100'
                  : 'tw-text-gray-600 dark:tw-text-gray-300'
              "
              >{{ "common.selectAll" | translate }}</label
            >
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let claim of claims; let i = index">
        <tr
          class="claim-row"
          [attr.data-id]="claim.id"
          [class.d-none]="!claim.isVisible"
        >
          <td class="tw-flex !tw-border-b-0 p-4 tw-w-full">
            <!-- checkbox -->
            <div class="form-check tw-flex-center tw-mb-0">
              <input
                type="checkbox"
                class="form-check-input tw-ml-2"
                [(ngModel)]="claim.selected"
                (input)="onChangeClaimsStatus()"
                [attr.data-checkbox-id]="claim.id"
              />
            </div>

            <div
              class="tw-flex tw-justify-between tw-items-center tw-mr-5 tw-mb-0 tw-w-full"
            >
              <!-- title -->
              <div
                class="tw-text-right tw-flex tw-w-full tw-cursor-pointer"
                (click)="onChangeClaimSelected(claim)"
              >
                <span class="tw-font-medium">
                  {{ claim.title }}
                </span>

                <div
                  *ngIf="claim.isDefault"
                  class="tw-mx-5"
                  [matTooltip]="'common.mainClaim' | translate"
                >
                  <i class="mdi mdi-star mdi-18px text-warning"></i>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </ng-container>

      <!-- empty -->
      <ng-container *ngIf="claims?.length == 0 || !isVisibleAllClaims()">
        <div
          class="tw-flex tw-justify-center tw-mt-[30px] tw-mb-[20px] tw-text-lg text-gray tw-font-medium"
        >
          {{ "common.empty" | translate }}
        </div>
      </ng-container>
    </tbody>
  </table>
</div>
